import { render, staticRenderFns } from "./vCISO.vue?vue&type=template&id=45c4f339&scoped=true"
import script from "./vCISO.vue?vue&type=script&lang=js"
export * from "./vCISO.vue?vue&type=script&lang=js"
import style0 from "./vCISO.vue?vue&type=style&index=0&id=45c4f339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c4f339",
  null
  
)

export default component.exports